document.addEventListener('DOMContentLoaded', initAnnouncementBar);
document.addEventListener('shopify:section:load', initAnnouncementBar);

function initAnnouncementBar() {
    const sliderEl = document.querySelector('.block__announcement-bar-slider');

    if (sliderEl) {
        new Swiper('.block__announcement-bar-slider', {
            direction: 'vertical',
            slidesPerView: 1,
            loop: true,
            autoHeight: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: '.block__announcement-bar-slider-arrow.swiper-button-next',
                prevEl: '.block__announcement-bar-slider-arrow.swiper-button-prev',
            },
        });
    }
}